import React from 'react';
import styled from 'styled-components';

import { DropdownSelectArrow } from './DropdownSelectArrow';

type Props = {
    isOpen: boolean;
    disabled?: boolean;
    setOpen?: (isOpen: boolean) => void;
    children: React.ReactNode;
    outline?: boolean;
    backgroundColor?: string;
};

const Trigger = styled.div<{ outline: boolean; backgroundColor?: string }>`
    position: relative;
    display: flex;
    align-items: center;
    padding: 5px 8px;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    font-weight: ${({ theme }) => theme.bento.font.primary.weight.medium};
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    color: ${({ theme }) => theme.bento.colors.text.main};
    border: ${p => (p.outline ? `1px solid ${p.theme.bento.colors.border.main}` : '')};
    border-radius: ${({ theme }) => theme.bento.radius}px;
    &[aria-disabled='true'] {
        color: ${({ theme }) => theme.bento.colors.text.weak};
        cursor: not-allowed;
    }
    background-color: ${p => p.backgroundColor || p.theme.bento.colors.background.main};
`;

export const DropdownSelectTrigger = React.forwardRef<HTMLDivElement, Props>(
    ({ disabled, isOpen, children, setOpen = () => {}, outline = true, backgroundColor }, ref) => {
        const onClick = React.useCallback(() => {
            if (!disabled) {
                setOpen(!isOpen);
            }
        }, [isOpen, disabled]);
        return (
            <Trigger
                ref={ref}
                aria-disabled={disabled}
                onClick={onClick}
                outline={outline}
                tabIndex={0}
                onKeyPress={event => event.key === 'Enter' && onClick()}
                backgroundColor={backgroundColor}
            >
                {children}
                <DropdownSelectArrow isOpen={isOpen} disabled={disabled} />
            </Trigger>
        );
    },
);
